import { makeObservable, observable } from 'mobx';

import {
  USERS_ALL_SELECTOR_ID,
  UsersFileType
} from 'shared/entities/usersList';
import { IEdit } from 'shared/entities/edit';

export default class UsersUploadFileEditModel implements IEdit {
  listId: string | null;
  channelId: string | null;
  chatId: string | null;
  file: File | null;
  fileType: UsersFileType;
  overwriteUsersVars: boolean;

  constructor({
    listId,
    chatId,
    channelId,
    file,
    fileType,
    overwriteUsersVars
  }: {
    listId: string | null;
    channelId: string | null;
    chatId: string | null;
    file: File | null;
    fileType: UsersFileType;
    overwriteUsersVars: boolean;
  }) {
    this.listId = listId;
    this.channelId = channelId;
    this.chatId = chatId;
    this.file = file;
    this.fileType = fileType;
    this.overwriteUsersVars = overwriteUsersVars;

    makeObservable(this, {
      listId: observable,
      channelId: observable,
      chatId: observable,
      file: observable,
      fileType: observable,
      overwriteUsersVars: observable
    });
  }

  toJson() {
    const isXlsx = this.fileType === UsersFileType.xlsx;

    const data: {
      channel_id: string | null;
      chat_id?: string;
      list_id?: string;
      file: File | null;
      overwrite_user_vars?: boolean;
    } = {
      channel_id: this.channelId,
      file: this.file
    };

    if (this.chatId) {
      data.chat_id = this.chatId;
    }

    if (isXlsx) {
      data.overwrite_user_vars = this.overwriteUsersVars;
    }

    if (this.listId && this.listId !== USERS_ALL_SELECTOR_ID) {
      data.list_id = this.listId;
    }

    return data;
  }

  getCopy(): UsersUploadFileEditModel {
    return new UsersUploadFileEditModel({
      listId: this.listId,
      chatId: this.chatId,
      channelId: this.channelId,
      fileType: this.fileType,
      file: this.file,
      overwriteUsersVars: this.overwriteUsersVars
    });
  }
}
